export default __webpack_public_path__ + "static/media/nft.5769dcb5.png";